// extracted by mini-css-extract-plugin
export default {"video-item":"video-player_video-item__mI5du","controls":"video-player_controls__OV6Ub","status":"video-player_status__VUEoO"};